import { Button, Stack } from '@mui/material';
import React from 'react';
import colors from '../../styles/colors';
import componentStyles from '../../styles/componentStyles';
import { ProcessTypes } from '../../AppUtils/CreateOpportunitiesUtils/JobsProcessesPage';
import globalStyles from '../../utilities/styles';


const Footer = (props) => {
  const {
    processType,
    setCurrentProcess,
    handleSubmit,
    handleBack,
    showBack = false,
    submitTitle = ''
  } = props;

  return (
    <>
      <Stack display={'flex'} flexDirection={'row'} justifyContent={'center'}
        sx={{ width: globalStyles.fieldWidth, mt: '50px', alignSelf: 'center' }}>
        {showBack &&
          <Button variant="outlined" sx={{
            color: colors.primary,
            borderColor: colors.primary,
            borderRadius: 50,
            padding: '10px 10px',
            width: componentStyles.buttonWidth,

          }}
            onClick={handleBack}
          >Back</Button>
        }
        <Button variant="contained" sx={{
          backgroundColor: colors.primary,
          borderRadius: 50,
          padding: '10px 10px',
          ml: '20px',
          width: componentStyles.buttonWidth,
        }}
          onClick={handleSubmit}
        >{submitTitle}</Button>
      </Stack>
    </>
  )
}

export default Footer;